import React from 'react'
import hoistStatics from 'hoist-non-react-statics'
import { logger, metrics } from 'lib/slardar-utils'
import isNode from 'lib/is-node'

/**
 * A public higher-order component to try catch for ssr render
 */
function TryCatchRender(Component: (props: any) => any) {
  const C = (props: any) => {
    try {
      return <>{Component(props)}</>
    } catch (error) {
      const errMsg = `[try.catch.render] render error message: err=${error.message}`
      if (!isNode) {
        logger.error(errMsg, {
          src: window?.location?.href,
        })
        metrics.counter(`try.catch.render`, {
          url: window?.location?.href,
        })
      } else {
        console.error(errMsg)
      }
      return null
    }
  }
  return hoistStatics(C, Component)
}

export default TryCatchRender
